import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { BaseQuestionPreviewComponent, QuestionDescriptionComponent } from '../../../bases';
import { useQuestionContext } from '../../../core';
import { FillInBlankDescription } from './components';
import { jsx as _jsx } from "react/jsx-runtime";
export var FillInBlankPreviewComponent = function FillInBlankPreviewComponent(_ref) {
  var _states$isShowCorrect;

  var states = _ref.states,
      actions = _ref.actions;

  var _useQuestionContext = useQuestionContext(),
      question = _useQuestionContext.question;

  var customDescription = /*#__PURE__*/_jsx(QuestionDescriptionComponent, {
    description: question.description,
    label: states.label,
    content: /*#__PURE__*/_jsx(FillInBlankDescription, {
      description: question.description,
      answers: states.answers,
      question: question,
      startQuestionIndex: question.index,
      onAnswer: actions.onAnswer,
      readOnly: states.readonly,
      isShowCorrectAnswer: (_states$isShowCorrect = states.isShowCorrectAnswer) !== null && _states$isShowCorrect !== void 0 ? _states$isShowCorrect : false
    })
  });

  return /*#__PURE__*/_jsx(BaseQuestionPreviewComponent, {
    states: _objectSpread(_objectSpread({}, states), {}, {
      customDescription: customDescription
    }),
    actions: actions
  });
};